import { IconButton, OdinIconSize, Tooltip } from '@myosh/odin-components';
import { useTranslation } from 'react-i18next';

interface CloseButtonProps {
  onClick: () => void;
  disabled?: boolean;
  spin?: boolean;
  size?: OdinIconSize;
}

const CloseActiveItemButton = ({ onClick, disabled, spin, size }: CloseButtonProps) => {
  const { t } = useTranslation();

  return (
    <Tooltip description={String(t('close'))} tooltipClassName="bg-mono-1" debounceTime={200}>
      <IconButton
        icon={spin ? 'Loader' : 'X'}
        iconSize={size}
        spin={spin}
        classNames="border-transparent hover:text-primary-2"
        onClick={onClick}
        disabled={disabled}
      />
    </Tooltip>
  );
};
export default CloseActiveItemButton;
